import {message} from "antd";
import {
  listBoPhanMuaSam,
  listChiPhiChinhMuaSam,
  listDiaDiemMuaSam,
  listNguonThanhToanMuaSam,
  listTrangThaiMuaSam,
} from "data/list";
import {validateMaxMin} from "helper/validate";
import {options} from "pages/NurseOut/ExamHistory/config";
import {FIELD_TYPE} from "types/enums";

const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Người đề nghị",
    name: "nguoiDeNghi",
    rules: [{required: true, message: "Chưa nhập người đề nghị"}],
  },
  {
    type: AUTO_COMPLETE,
    label: "Bộ phận",
    name: "boPhan",
    options: listBoPhanMuaSam,
  },
  {
    type: INPUT,
    label: "Tên đề nghị",
    name: "tenDeNghi",
  },
  {
    type: INPUT,
    label: "Nội dung",
    name: "moTa",
    rules: [{required: true, message: "Chưa nhập nội dung"}],
  },
  {
    type: COMBO_BOX,
    label: "Nhà cung cấp",
    name: "nhaCungCap",
  },
  {
    type: AUTO_COMPLETE,
    label: "Địa điểm",
    name: "diaDiem",
    options: listDiaDiemMuaSam,
  },
  {
    type: DATE,
    label: "Thời gian",
    name: "timeLine",
    disableDate: false,
  },
  {
    type: INPUT,
    label: "Lý do từ chối",
    name: "lyDoTuChoi",
    disable: true,
    // hide: true,
  },
  {
    type: INPUT,
    label: "Trạng thái",
    name: "trangThaiStr",
    disabled: true,
  },
];
const columns: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    type: INPUT,
    title: "Item nội dung",
    dataIndex: "noiDung",
    align: "right",
    show: true,
    width: 250,
    rules: [{required: true, message: "Chưa nhập nội dung"}],
  },
  {
    type: CURRENCY,
    dataIndex: "donGia",
    key: "donGia",
    title: "Giá tiền",
    show: true,
    width: 200,
    rules: [{required: true, message: "Chưa nhập đơn giá"}],
  },
  {
    type: NUMBER,
    dataIndex: "soLuong",
    key: "soLuong",
    title: "Số lượng",
    align: "right",
    show: true,
    width: 120,
    rules: [{required: true, message: "Chưa nhập số lượng"}],
  },
  {
    type: NUMBER,
    dataIndex: "vat",
    key: "vat",
    title: "VAT (%)",
    align: "right",
    show: true,
    width: 120,
    rules: [
      {
        validator: async (_, value) => {
          await validateMaxMin("max", value, 100);
        },
        message: "Giá trị VAT không lớn hơn 100",
      },
    ],
  },
  {
    type: CURRENCY,
    dataIndex: "thanhTien",
    key: "thanhTien",
    title: "Thành tiền",
    show: true,
    width: 240,
    disabled: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "nganSach",
    key: "nganSach",
    title: "Dòng ngân sách",
    show: true,
    width: 200,
    rules: [{required: true, message: "Chưa nhập dòng ngân sách"}],
  },
  {
    type: COMBO_BOX,
    dataIndex: "nguonThanhToan",
    key: "nguonThanhToan",
    title: "Nguồn thanh toán",
    show: true,
    width: 200,
    rules: [{required: true, message: "Chưa nhập nguồn thanh toán"}],
  },
  {
    type: COMBO_BOX,
    dataIndex: "chiPhiChinh",
    key: "chiPhiChinh",
    title: "Chi phí chính",
    show: true,
    width: 200,
    options: listChiPhiChinhMuaSam,
    rules: [{required: true, message: "Chưa nhập chi phí chính"}],
  },
  {
    type: COMBO_BOX,
    dataIndex: "duAn",
    key: "duAn",
    title: "Dự án",
    show: true,
    width: 200,
    rules: [{required: true, message: "Chưa chọn dự án"}],
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {fields, columns};
